// Custom screen-share picker for the Electron shell (F-CALL-2). The main
// process intercepts getDisplayMedia and asks us to choose; we render our own
// themed picker instead of Chromium's default. No-op in the browser.

import { MouseEvent, useCallback, useEffect, useState } from 'react';

import { resolveSharePick, ShareSource, sharePickerEvents } from '../desktop';

export function ShareSourcePicker() {
  const [sources, setSources] = useState<ShareSource[] | null>(null);

  useEffect(() => sharePickerEvents.on('request', (list) => setSources(list)), []);

  const pick = useCallback((id: string | null) => {
    resolveSharePick(id);
    setSources(null);
  }, []);
  const onPick = useCallback(
    (e: MouseEvent<HTMLButtonElement>) => pick(e.currentTarget.dataset.id ?? null),
    [pick],
  );
  const cancel = useCallback(() => pick(null), [pick]);

  if (!sources) return null;
  return (
    <div className="bz-sheet-backdrop" onClick={cancel}>
      <div className="bz-sheet bz-share-picker" role="dialog" aria-label="Choose what to share">
        <h2>Choose what to share</h2>
        <div className="bz-share-grid">
          {sources.map((s) => (
            <button key={s.id} className="bz-share-source" data-id={s.id} onClick={onPick}>
              <img src={s.thumbnail} alt="" className="bz-share-thumb" />
              <span className="bz-share-name">{s.name}</span>
            </button>
          ))}
        </div>
        <button className="bz-btn" onClick={cancel}>
          Cancel
        </button>
      </div>
    </div>
  );
}
